import { useCurrentBreakPoint } from './use-current-breakpoint';
export function useResponsiveProps(props) {
    const { responsive, breakPoints } = props;
    const responsiveBreakPoints = responsive.map((resp) => resp.breakPoint);
    const currentBreakPoint = useCurrentBreakPoint(breakPoints);
    const getActiveBreakPoints = (currentBreakPoint, responsiveBP) => {
        const sortedResponsiveBreakPoints = responsiveBP.sort((x, y) => breakPoints[x] - breakPoints[y]);
        return sortedResponsiveBreakPoints.filter((breakPoint) => {
            return breakPoints[breakPoint] <= breakPoints[currentBreakPoint];
        });
    };
    const getResponsiveProps = (breakPoint) => {
        const responsiveObject = responsive.find((resp) => resp.breakPoint === breakPoint);
        /* istanbul ignore else */
        if (responsiveObject) {
            return responsiveObject.props;
        }
    };
    if (!currentBreakPoint) {
        return {};
    }
    const activeBreakPoints = getActiveBreakPoints(currentBreakPoint, responsiveBreakPoints);
    return activeBreakPoints.reduce((acc, breakPoint) => (Object.assign(Object.assign({}, acc), getResponsiveProps(breakPoint))), {});
}
